// src/components/CookieConsentManager.js

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useCookieConsent } from "../context/ConsentContext";
import "./CookieConsentManager.css";

const CookieConsentManager = () => {
  const {
    consent,
    isModalOpen,
    updateConsent,
    acceptAll,
    declineAll,
    consentCategories,
  } = useCookieConsent();

  const [localConsent, setLocalConsent] = useState({});
  const [view, setView] = useState("main"); // "main" oder "settings"

  useEffect(() => {
    if (isModalOpen) {
      setLocalConsent(
        consent ||
          consentCategories.reduce(
            (acc, cat) => ({ ...acc, [cat.id]: cat.isMandatory }),
            {},
          ),
      );
    }
  }, [isModalOpen, consent, consentCategories]);

  const handleToggle = (id) => {
    setLocalConsent((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleSave = () => {
    updateConsent(localConsent);
  };

  // Wenn das Modal nicht offen ist, rendern wir nichts.
  if (!isModalOpen) {
    return null;
  }

  const renderMainView = () => (
    <div className="cookie-modal-main">
      <h2>Diese Webseite verwendet Cookies</h2>
      <p>
        Neben technisch notwendigen Cookies, verwenden wir auf unserer Webseite auch Cookies, um
        die Erfahrung auf unserer Webseite zu optimieren. Hierfür verwenden wir analytische Cookies, die
        jedoch erst eingesetzt werden, wenn Sie zugestimmt haben. Die generierten Informationen
        können zwar an Drittparteien weitergeleitet werden, aber nicht mit persönlichen Informationen
        kombiniert werden.
      </p>
      <div className="cookie-modal-actions-main">
        <button className="btn-settings" onClick={() => setView("settings")}>
          EINSTELLUNGEN
        </button>
        <button className="btn-accept" onClick={acceptAll}>
          AKZEPTIEREN
        </button>
        <button className="btn-decline" onClick={declineAll}>
          ABLEHNEN
        </button>
      </div>
      <div className="cookie-modal-footer">
        <div className="footer-links">
          <Link to="/impressum">Impressum</Link> &nbsp;|&nbsp; <Link to="/datenschutz">Datenschutzerklärung</Link>
        </div>
        <div className="footer-powered">Powered by MEKO</div>
      </div>
    </div>
  );

  const renderSettingsView = () => (
    <div className="cookie-modal-settings">
      <h2>Cookie-Einstellungen</h2>
      <p>
        Passen Sie Ihre Cookie-Präferenzen an. Einige Cookies sind für die Funktionalität der Website notwendig, andere helfen uns bei der Analyse und im Marketing.
      </p>
      <div className="cookie-categories">
        {consentCategories.map((category) => (
          <div key={category.id} className="cookie-category">
            <div className="category-header">
              <label>
                <input
                  type="checkbox"
                  checked={localConsent[category.id] || false}
                  onChange={() => handleToggle(category.id)}
                  disabled={category.isMandatory}
                />
                <strong>{category.name}</strong>
              </label>
            </div>
            <p className="category-description">{category.description}</p>
          </div>
        ))}
      </div>
      <div className="cookie-modal-actions-settings">
        <button className="btn-settings" onClick={() => setView("main")}>
          ZURÜCK
        </button>
        <button className="btn-accept" onClick={handleSave}>
          SPEICHERN
        </button>
      </div>
      <div className="cookie-modal-footer">
        <div className="footer-links">
          <Link to="/impressum">Impressum</Link> &nbsp;|&nbsp; <Link to="/datenschutz">Datenschutzerklärung</Link>
        </div>
        <div className="footer-powered">Powered by MEKO</div>
      </div>
    </div>
  );

  return (
    <div className="cookie-modal-overlay">
      <div className="cookie-modal">
        {view === "main" ? renderMainView() : renderSettingsView()}
      </div>
    </div>
  );
};

export default CookieConsentManager;
